
export const cpromInstanceTemplateMap = new Map([
    ['advance-v2', '基础版'],
]);
